export default "__VITE_ASSET__CGuHZphD__"